// Logger-side of bootstrap. Console transport is registered eagerly by the
// logger module itself; this step adds the Sentry breadcrumb/event transport
// once Sentry has been initialised. Order matters: must run *after* initSentry.

import { flags } from '@core/config'
import { registerTransport, sentryTransport } from '@core/logging'

export const initLogger = (): void => {
  if (flags.sentryEnabled) registerTransport(sentryTransport)
}
